import { type ReactNode } from 'react';

import { Row as BootstrapRow } from 'react-bootstrap';

interface Props {
  className: string;
  children: ReactNode;
}

const Row = ({ className, children }: Partial<Props>) => {
  return <BootstrapRow className={className}>{children}</BootstrapRow>;
};

export { Row };
